/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnResponsibility.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import HomepageMenuCn from "../../assets/component/HomepageMenuCn/HomepageMenuCn.js";

class CnResponsibility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="CnResponsibility-view">
        {!!this.state.showModal && (
          <HomepageMenuCn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="CnResponsibility-first">
          <div className="CnResponsibility-firstContainer">
            <div className="CnResponsibility-firstHeading">
              扎根香港，与香港同行
            </div>
            <div className="CnResponsibility-firstsubHeading">
              CheckPlus 与社会各行各业合作及交流
            </div>
          </div>
        </div>

        <div className="CnResponsibility-second">
          <div className="CnResponsibility-content">
            <div className="CnResponsibility-picture1" />
            <div className="CnResponsibility-description">
              跟不同慈善机构分享及交流
            </div>
            <div className="CnResponsibility-picture2" />
            <div className="CnResponsibility-description">
              获邀出席不同慈善机构活动
            </div>
            <div className="CnResponsibility-picture3" />
            <div className="CnResponsibility-description">
              跟影音使团讲解 CheckPlus 平台
              <br />
              赖钧豪先生 (左) 及 袁文辉先生 (右)
            </div>
            <div className="CnResponsibility-picture4" />
            <div className="CnResponsibility-description">
              叶家宝先生 (左) 及 赖钧豪先生 (右)
            </div>
            <div className="CnResponsibility-picture5" />
            <div className="CnResponsibility-description">
              许朝英社长(左)、￼邱腾华 (商务及经济发展局) 局长 (中) 及 赖钧豪先生
            </div>
          </div>
        </div>

        <div className="CnResponsibility-footer">
          <div className="CnResponsibility-footerNav">
            <Link to="/CnTeam">
              <div className="CnResponsibility-footerNavItem">创办人的故事</div>
            </Link>
            <Link to="/CnFaq">
              <div className="CnResponsibility-footerNavItem">常见问题</div>
            </Link>
            <Link to="/CnContact">
              <div className="CnResponsibility-footerNavItem">联络我们</div>
            </Link>
          </div>

          <div className="CnResponsibility-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default CnResponsibility;
